// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  border-radius: 0.5rem;
}
.card .card-header {
  border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;
}

.grid-container-card .card-body {
  min-height: 350px;
  max-height: 450px;
  overflow: hidden;
  padding: 1rem;
}

.small {
  font-size: 80%;
}

@media (max-width: 767.98px) {
  .tenant-title {
    flex-wrap: wrap;
    font-size: 1.35rem;
    overflow-wrap: anywhere;
  }
  .tenant-heading > div:last-child {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .tenant-heading > div:last-child > span {
    margin: 0 !important;
  }
  .tenant-heading .badge {
    white-space: normal;
    text-align: left;
  }
  .tenant-heading .h5 {
    font-size: 0.8rem;
    overflow-wrap: anywhere;
  }
  .grid-container-card .card-body {
    min-height: 280px;
    max-height: 360px;
    padding: 0.5rem;
  }
  .card-body {
    padding: 1rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/tenant-detail/tenant-detail.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,wDAAA;AACJ;;AAKE;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AAFJ;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE;IACE,eAAA;IACA,kBAAA;IACA,uBAAA;EAHF;EAMA;IACE,aAAA;IACA,eAAA;IACA,WAAA;EAJF;EAOA;IACE,oBAAA;EALF;EAQA;IACE,mBAAA;IACA,gBAAA;EANF;EASA;IACE,iBAAA;IACA,uBAAA;EAPF;EAUA;IACE,iBAAA;IACA,iBAAA;IACA,eAAA;EARF;EAWA;IACE,wBAAA;EATF;AACF","sourcesContent":[".card {\n  border-radius: 0.5rem;\n\n  .card-header {\n    border-radius: calc(0.5rem - 1px) calc(0.5rem - 1px) 0 0;\n  }\n}\n\n// Specific styling for gateway and device grid containers\n.grid-container-card {\n  .card-body {\n    min-height: 350px;\n    max-height: 450px;\n    overflow: hidden;\n    padding: 1rem;\n  }\n}\n\n.small {\n  font-size: 80%;\n}\n\n@media (max-width: 767.98px) {\n  .tenant-title {\n    flex-wrap: wrap;\n    font-size: 1.35rem;\n    overflow-wrap: anywhere;\n  }\n\n  .tenant-heading > div:last-child {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n  }\n\n  .tenant-heading > div:last-child > span {\n    margin: 0 !important;\n  }\n\n  .tenant-heading .badge {\n    white-space: normal;\n    text-align: left;\n  }\n\n  .tenant-heading .h5 {\n    font-size: 0.8rem;\n    overflow-wrap: anywhere;\n  }\n\n  .grid-container-card .card-body {\n    min-height: 280px;\n    max-height: 360px;\n    padding: 0.5rem;\n  }\n\n  .card-body {\n    padding: 1rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
